import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream py-14 sm:py-16 lg:py-20" aria-labelledby="faq" data-id="element-32" data-mp="1bl24hbm2lcg2">
      <div className="mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-33" data-mp="1gjc0fofmch2q">
        <h2 id="faq" className="font-display text-3xl font-extrabold leading-[1.1] tracking-tight text-ink sm:text-4xl" data-id="element-34" data-mp="1gjvhz41cx3g8">
          Preguntas que nos hacen siempre
        </h2>

        <div className="mt-8 divide-y divide-ink/10 border-y border-ink/10" data-id="element-35" data-mp="28cvxykdhs32q">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} data-id="element-36" data-mp="1zh6g2lb95qu3" data-mpi={i}>
                <h3 data-id="element-37" data-mp="1zg4u3lsp7jxl">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-start justify-between gap-4 py-5 text-left transition-colors duration-150 ease-out hover:text-verde-dark" data-id="element-38" data-mp="2n8bvizda6h3v">
                    <span className="font-display text-lg font-bold leading-snug text-ink" data-id="element-39" data-mp="1ektt4z0pkiv4">
                      {faq.q}
                    </span>
                    <PlusIcon className={`mt-0.5 h-5 w-5 shrink-0 text-verde transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-40" data-mp="19stz1n7bkk6g" />
                  </button>
                </h3>
                <div id={`faq-panel-${i}`} hidden={!isOpen} className="pb-5 pr-8 text-[15px] leading-relaxed text-ink-soft sm:text-base" data-id="element-41" data-mp="1xhlldxy8a8bb">
                  {faq.a}
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}